// Minimal BCP 47 helpers for DSL parsing without coupling to UI enums

export function isWellFormedLocale(tag: string): boolean {
  // Stricter BCP47-ish pattern (language ["en"], optional script, optional region, optional variants)
  // - Primary language: 2-3 letters
  // - Script: 4 letters
  // - Region: 2 letters or 3 digits
  // - Variants: 5-8 alphanum or 4 starting with a digit
  // This intentionally rejects singleton extensions like "-a-" used in the test string 'not-a-locale'.
  const re =
    /^(?:[A-Za-z]{2,3})(?:-[A-Za-z]{4})?(?:-(?:[A-Za-z]{2}|\d{3}))?(?:-(?:[A-Za-z0-9]{5,8}|\d[A-Za-z0-9]{3}))*$/u;
  return re.test(tag);
}

export function canonicalizeLocale(tag: string): string {
  try {
    const arr: string[] = Intl.getCanonicalLocales([tag]);
    return arr[0];
  } catch {
    return tag;
  }
}
